import { Component, OnInit } from '@angular/core';
import { NgForm} from '@angular/forms';
import { UserService } from '../../shared/user.service';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';
import { zip } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import { templateSourceUrl } from '@angular/compiler';

@Component({
  selector: 'app-export-to-machine',
  templateUrl: './export-to-machine.component.html',
  styleUrls: ['./export-to-machine.component.css']
})
export class ExportToMachineComponent implements OnInit {
  title = "Export To Machine";
  formexport:any={};
  imppthd:any;
  imppthopt:any={};
  bckpthd: any;
  bckopt: any={};
  agntd:any;
  agtopt:any={};
  ag:any=[];
  DateValues:string;
  today = new Date();  
  expdat:any;
  filedata:any;

  constructor(private service:UserService,private datePipe:DatePipe) { }

  ngOnInit() 
  {
   this.importpathpig();
   this.backuppathdet();
   this.agentsel();
   debugger;
   this.formexport.exp_date=this.getdatefun(this.today);
  
  }

  importpathpig()
  {
    this.imppthd=this.service.pigmyimppath();
    this.imppthd.subscribe(
      (pthres:any)=>{
        this.imppthopt=pthres;
        console.log(pthres);
        this.formexport.readpath=pthres.STAT;
      }
    )
  }
  backuppathdet()
  {
    this.bckpthd=this.service.pigmybackuppath();
    this.bckpthd.subscribe(
      (bckres:any)=>{
        this.bckopt=bckres;
        console.log(bckres);
        this.formexport.bckpath=bckres.STAT;
      }
    )
  }

  agentsel()
  {
    this.agntd=this.service.selectagent();
    this.agntd.subscribe(
      (agres:any)=>{
        this.agtopt=agres;
        console.log(this.agtopt);
      }
    )
  }

  changeagnt(rec:any,ag:any)
  {
    debugger
    // var chcking=ag[rec-1];
    // console.log(chcking.AGENT_DESC);
    this.agntselctempty=false;
    this.formexport.agntname=rec;
  }

  getdatefun(indt:any)
  {
    debugger;
    this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }
  agntselctempty:boolean=false;
  expdata(agnt_id:number)
  {
    if(agnt_id==undefined||null)
    {
      this.agntselctempty=true;
      swal('Agent','Select a agent to continue','warning');
    }
      
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
      this.expdat=this.service.pigmyexport(agnt_id);
      this.expdat.subscribe(
        (response:any)=>
        {
          debugger;
          console.log('Reposnse');
          console.log(response);
          this.service.getfileexp();
          this.resetForm(this.formexport); 
          document.getElementById('loader-spinner').style.display = "none";         
          swal("Export","Data exported connect to machine","warning");
          //this.fetchfile2();
        }

       
      )

      document.getElementById('loader-spinner').style.display = "none";
  }

  resetForm(form?:NgForm)
 {
  if(form!=null)
  {
    this.formexport.agntselct=null;
    this.formexport.agntname='';   
  }
 }



}



// WEBPACK FOOTER //
// ./src/app/general-transaction/export-to-machine/export-to-machine.component.ts